var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\u0421\u043B\u043E\u0439_1",
    "data-name": "\u0421\u043B\u043E\u0439 1",
    width: 512,
    height: 124,
    viewBox: "0 0 512 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#&#x411;&#x435;&#x437;&#x44B;&#x43C;&#x44F;&#x43D;&#x43D;&#x44B;&#x439;_&#x433;&#x440;&#x430;&#x434;&#x438;&#x435;&#x43D;&#x442;_2);}.cls-3{fill:url(#&#x411;&#x435;&#x437;&#x44B;&#x43C;&#x44F;&#x43D;&#x43D;&#x44B;&#x439;_&#x433;&#x440;&#x430;&#x434;&#x438;&#x435;&#x43D;&#x442;_2-2);}.cls-4{fill:url(#&#x411;&#x435;&#x437;&#x44B;&#x43C;&#x44F;&#x43D;&#x43D;&#x44B;&#x439;_&#x433;&#x440;&#x430;&#x434;&#x438;&#x435;&#x43D;&#x442;_2-3);}.cls-5{fill:url(#&#x411;&#x435;&#x437;&#x44B;&#x43C;&#x44F;&#x43D;&#x43D;&#x44B;&#x439;_&#x433;&#x440;&#x430;&#x434;&#x438;&#x435;&#x43D;&#x442;_2-4);}.cls-6{fill:url(#&#x411;&#x435;&#x437;&#x44B;&#x43C;&#x44F;&#x43D;&#x43D;&#x44B;&#x439;_&#x433;&#x440;&#x430;&#x434;&#x438;&#x435;&#x43D;&#x442;_2-5);}.cls-7{fill:url(#&#x411;&#x435;&#x437;&#x44B;&#x43C;&#x44F;&#x43D;&#x43D;&#x44B;&#x439;_&#x433;&#x440;&#x430;&#x434;&#x438;&#x435;&#x43D;&#x442;_2-6);}.cls-8{fill:url(#&#x411;&#x435;&#x437;&#x44B;&#x43C;&#x44F;&#x43D;&#x43D;&#x44B;&#x439;_&#x433;&#x440;&#x430;&#x434;&#x438;&#x435;&#x43D;&#x442;_2-7);}.cls-9{fill:url(#&#x411;&#x435;&#x437;&#x44B;&#x43C;&#x44F;&#x43D;&#x43D;&#x44B;&#x439;_&#x433;&#x440;&#x430;&#x434;&#x438;&#x435;&#x43D;&#x442;_2-8);}.cls-10{fill:url(#&#x411;&#x435;&#x437;&#x44B;&#x43C;&#x44F;&#x43D;&#x43D;&#x44B;&#x439;_&#x433;&#x440;&#x430;&#x434;&#x438;&#x435;&#x43D;&#x442;_2-9);}.cls-11{fill:url(#&#x411;&#x435;&#x437;&#x44B;&#x43C;&#x44F;&#x43D;&#x43D;&#x44B;&#x439;_&#x433;&#x440;&#x430;&#x434;&#x438;&#x435;&#x43D;&#x442;_2-10);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -55.34,
    y1: 62.06,
    x2: 207.86,
    y2: 62.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000d03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#01723c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#005731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#37b869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#005731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#005a32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#006635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#006e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#018740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#02a04b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#02a44e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#37b869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#37b869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#37b869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#005731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#004426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030805"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2",
    x1: 127.86,
    y1: 4.63,
    x2: 127.86,
    y2: 147.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#004a2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#002e1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#001609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000d03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2-2",
    x1: 164.58,
    y1: 4.63,
    x2: 164.58,
    y2: 147.06,
    xlinkHref: "#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2-3",
    x1: 214.59,
    y1: 4.63,
    x2: 214.59,
    y2: 147.06,
    xlinkHref: "#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2-4",
    x1: 260.58,
    y1: 4.63,
    x2: 260.58,
    y2: 147.06,
    xlinkHref: "#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2-5",
    x1: 301.7,
    y1: 4.63,
    x2: 301.7,
    y2: 147.06,
    xlinkHref: "#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2-6",
    x1: 341.65,
    y1: 4.63,
    x2: 341.65,
    y2: 147.06,
    xlinkHref: "#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2-7",
    x1: 387.04,
    y1: 4.63,
    x2: 387.04,
    y2: 147.06,
    xlinkHref: "#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2-8",
    x1: 419.75,
    y1: 4.63,
    x2: 419.75,
    y2: 147.06,
    xlinkHref: "#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2-9",
    x1: 450.97,
    y1: 4.63,
    x2: 450.97,
    y2: 147.06,
    xlinkHref: "#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2-10",
    x1: 494.48,
    y1: 4.63,
    x2: 494.48,
    y2: 147.06,
    xlinkHref: "#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.65,20.66l-3.71,8.93-35.2,84.82L35.87,103.52,84.14,26.24h0l5.08-8.13-3.89-2.25L79,23.28,19,93.76,9.58,88.35V80.67L73.17,19.91,80.39,13,76.9,11,62.17,2.49a14.11,14.11,0,0,0-14.11,0l-41,23.68A14.09,14.09,0,0,0,0,38.38V85.74A14.1,14.1,0,0,0,7.05,98l41,23.68a14.11,14.11,0,0,0,14.11,0l41-23.68a14.1,14.1,0,0,0,7-12.21V38.38a14.09,14.09,0,0,0-7-12.21ZM11.79,34.5,52.92,10.75a4.43,4.43,0,0,1,4.4,0L68.19,17,9.58,57.7V38.31A4.4,4.4,0,0,1,11.79,34.5ZM98.45,89.62,78.2,101.31,95.64,32.88l2.81,1.62a4.41,4.41,0,0,1,2.2,3.81V85.8A4.41,4.41,0,0,1,98.45,89.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.62,39.47H133.1V84.73H122.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.33,39.47V84.73h-8.6L154.17,57.25V84.73H143.83V39.47h8.66L175,67V39.47Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.31,39.47,219.72,84.73H209.38L189.86,39.47h11.31L214.94,71.8l14-32.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.1,76.32v8.41h-35V39.47h34.2v8.41H253.47V57.7h21v8.15h-21V76.32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.93,84.05a24.27,24.27,0,0,1-8-3.78l3.55-7.89a24.45,24.45,0,0,0,6.92,3.43,26,26,0,0,0,8,1.29q4.46,0,6.59-1.33a4,4,0,0,0,2.13-3.52,3.36,3.36,0,0,0-1.26-2.68,9.59,9.59,0,0,0-3.23-1.72c-1.32-.43-3.09-.9-5.33-1.42A73.67,73.67,0,0,1,291.81,64,13.65,13.65,0,0,1,286.15,60a10.66,10.66,0,0,1-2.36-7.24,12.59,12.59,0,0,1,2.13-7.14,14.36,14.36,0,0,1,6.44-5.08,26.19,26.19,0,0,1,10.5-1.87,34.77,34.77,0,0,1,8.47,1,25.1,25.1,0,0,1,7.24,3l-3.23,8A25.24,25.24,0,0,0,302.8,47.1c-2.93,0-5.1.48-6.5,1.42a4.35,4.35,0,0,0-2.1,3.75,3.67,3.67,0,0,0,2.42,3.46A37.64,37.64,0,0,0,304,58a74.27,74.27,0,0,1,8.47,2.46,14,14,0,0,1,5.65,3.88,10.42,10.42,0,0,1,2.36,7.17,12.37,12.37,0,0,1-2.16,7.08,14.54,14.54,0,0,1-6.5,5.08,26.5,26.5,0,0,1-10.54,1.87A37,37,0,0,1,290.93,84.05Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.42,48H321.93V39.47h39.44V48H346.89V84.73H336.42Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M395.83,84.73,387.1,72.12h-9.63V84.73H367V39.47h19.59a25.06,25.06,0,0,1,10.44,2,15.38,15.38,0,0,1,6.82,5.69,15.6,15.6,0,0,1,2.4,8.72,14.76,14.76,0,0,1-9.31,14.29l10.15,14.55ZM393.18,50c-1.64-1.36-4-2-7.18-2h-8.53V63.78H386q4.72,0,7.18-2.07a7.21,7.21,0,0,0,2.45-5.82A7.19,7.19,0,0,0,393.18,50Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M414.51,39.47H425V84.73H414.51Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M440.21,84.05a24.33,24.33,0,0,1-8-3.78l3.55-7.89a24.45,24.45,0,0,0,6.92,3.43,26.06,26.06,0,0,0,8,1.29q4.46,0,6.59-1.33a4,4,0,0,0,2.14-3.52,3.36,3.36,0,0,0-1.26-2.68,9.55,9.55,0,0,0-3.24-1.72q-2-.64-5.33-1.42A73.67,73.67,0,0,1,441.08,64,13.71,13.71,0,0,1,435.42,60a10.66,10.66,0,0,1-2.36-7.24,12.6,12.6,0,0,1,2.14-7.14,14.27,14.27,0,0,1,6.43-5.08,26.28,26.28,0,0,1,10.51-1.87,34.69,34.69,0,0,1,8.46,1,25.17,25.17,0,0,1,7.25,3l-3.24,8a25.24,25.24,0,0,0-12.54-3.56c-2.93,0-5.1.48-6.5,1.42a4.35,4.35,0,0,0-2.1,3.75,3.67,3.67,0,0,0,2.43,3.46A37.29,37.29,0,0,0,453.3,58a73.67,73.67,0,0,1,8.47,2.46,14.05,14.05,0,0,1,5.66,3.88,10.41,10.41,0,0,1,2.35,7.17,12.37,12.37,0,0,1-2.16,7.08,14.54,14.54,0,0,1-6.5,5.08,26.5,26.5,0,0,1-10.54,1.87A37,37,0,0,1,440.21,84.05Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M512,76.32v8.41H477V39.47h34.2v8.41H487.37V57.7h21v8.15h-21V76.32Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRise);
export default __webpack_public_path__ + "static/media/rise.7302ab8b3565425c0fd25c83f3c0fcda.svg";
export { ForwardRef as ReactComponent };